import {
    createGlobalStyle,
    styled,
    $error,
} from '@acko-tech/building-blocks.ui.common';

import Image from 'next/image';

export const GlobalStyle: any = createGlobalStyle`
    body {
        overflow-x: hidden !important;
    }
    scroll-behavior: auto;
`;

export const Flex = styled.div`
    display: flex;
`;

export const Img = styled(Image)`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
`;

export const CenterDiv = styled.div`
    display: flex;
    justify-content: center;
    ${(props) => props && props.styles};
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    align-items: center;
    margin-top: 10px;
`;

export const CheckboxText = styled.div`
    font-weight: 500;
    font-size: 12px;
    color: #434f5a;
    margin-left: 10px;
    margin-top: 2px;
`;

export const PageLoader = styled.img`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform: -webkit-translate(-50%, -50%);
    transform: -moz-translate(-50%, -50%);
    transform: -ms-translate(-50%, -50%);
    color: darkred;
    width: 100px;
`;

export const ButtonLoaderImage = styled.img`
    display: ${(props) => (props.visibility ? 'block' : 'none')};
    width: 65px;
    position: absolute;
    left: 50%;
    margin-top: ${(props) => props.marginTop || '30px'};
    transform: translate(-50%, -50%);
`;

export const ErrorMessage = styled.div`
    margin: 10px 0;
    font-size: 12px;
    color: ${$error};
    text-align: center;
`;
